/**
 * Route → Insight key map.
 *
 * The Insight overlay reads the current pathname and auto-anchors to
 * the matching module-level entry the moment Insight Mode opens —
 * without requiring `data-insight-id` attributes on every page's H1.
 *
 * The keys here must match entries registered in the backend
 * `insight_baseline.py`. Adding a new page = one line here.
 *
 * Exact paths first; for parameterised routes, add a `prefix` entry
 * (longest prefix wins).
 */

export const ROUTE_EXACT_MAP = {
    "/dashboard": "dashboard.overview",
    "/cards": "cards.overview",
    "/admin/card-fleet-ops": "card-fleet.overview",
    "/employees": "employees.overview",
    "/locations": "locations.overview",
    "/surveys": "surveys.overview",
    "/analytics": "analytics.overview",
    "/neo-status": "neo-status.overview",
    "/roi": "roi.overview",
    "/sales-report": "sales-report.overview",
    "/sales-calculation-tool": "sales-calculation-tool.overview",
    "/shift-insights": "shift-insights.overview",
    "/location-health": "location-health.overview",
    "/executive-summary": "executive-summary.overview",
    "/brand-comparison": "brand-comparison.overview",
    "/admin/brands": "admin-brands.overview",
    "/admin/clients": "admin-clients.overview",
    "/admin/users": "admin-users.overview",
    "/admin/settings": "admin-settings.overview",
    "/admin/platform-values": "platform-values.overview",
    "/admin/notifications": "notifications.overview",
    "/admin/audit-logs": "audit.overview",
    "/admin/permissions": "permissions.overview",
    "/management/audit": "management-audit.overview",
    "/voucher-reports": "voucher-reports.overview",
    "/voucher-settings": "voucher-settings.overview",
    "/manager-access": "manager-access.overview",
    "/operational-base": "operational-base.overview",
    "/operational-base/activity": "activity-pulse.overview",
    "/operational-base/activity/security": "activity-pulse.overview",
    "/operational-base/templates": "templates.overview",
    "/operational-base/review-assistant": "review-assistant.overview",
    "/operational-base/review-shield": "review-shield.overview",
};

// Parameterised routes — match by prefix. Longest match wins.
export const ROUTE_PREFIX_MAP = [
    { prefix: "/surveys/", key: "surveys.overview" },
];

export const resolveRouteInsight = (pathname) => {
    if (!pathname) return null;
    // Strip trailing slash for matching.
    const clean = pathname.replace(/\/+$/, "") || "/";
    if (ROUTE_EXACT_MAP[clean]) return ROUTE_EXACT_MAP[clean];
    // Longest prefix wins.
    let best = null;
    for (const { prefix, key } of ROUTE_PREFIX_MAP) {
        if (clean.startsWith(prefix) && (!best || prefix.length > best.prefix.length)) {
            best = { prefix, key };
        }
    }
    return best ? best.key : null;
};
